import Vue from 'vue'
import store from 'vuex-store'

export default {
  endpoint: 'cmslogout',
  async post (data) {
    try {
      await Vue.http.post(this.endpoint, data)
      store.commit('setProfile', {})
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  },
}



// WEBPACK FOOTER //
// ./src/application/cmslogout.js